import { useCallback } from 'react';

const useDropdown = () => {
  // 定义防滚动函数
  const preventScroll = useCallback((e) => {
    e.preventDefault();
  }, []);

  // 处理下拉框展开
  const handleOpen = useCallback(() => {
    // 禁用页面滚动
    // document.body.style.overflow = 'hidden'; //pc不禁
    // 移动端阻止默认滚动
    document.addEventListener('touchmove', preventScroll, { passive: false });
  }, [preventScroll]);

  // 处理下拉框关闭
  const handleClose = useCallback(() => {
    // 恢复页面滚动
    // document.body.style.overflow = ''; //pc不禁
    // 移除事件监听
    document.removeEventListener('touchmove', preventScroll);
  }, [preventScroll]);

  return { handleOpen, handleClose };
};

export default useDropdown;